import Reveal from '@/components/base/Reveal';
import { schemePairs } from '@/mocks/home';

export default function SchemeSection() {
  return (
    <section id="scheme" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-2xl">
          <span className="text-xs md:text-sm tracking-[0.2em] text-accent-600">CONTRAST · 骗局识别</span>
          <h3 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">“他们说的” 与 “背后的真相”</h3>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            招工话术往往听起来合理，把常见说法与可核对的事实摆在一起，判断会清晰很多。
          </p>
        </Reveal>

        <div className="mt-8 rounded-lg border border-background-200 overflow-hidden">
          <div className="hidden md:grid grid-cols-2 bg-background-100 border-b border-background-200">
            <div className="px-6 py-3.5 text-sm font-semibold text-accent-700 flex items-center gap-2">
              <i className="ri-chat-quote-line"></i>
              他们说的话术
            </div>
            <div className="px-6 py-3.5 text-sm font-semibold text-secondary-800 flex items-center gap-2 border-l border-background-200">
              <i className="ri-file-shield-2-line"></i>
              值得核对的事实
            </div>
          </div>

          {schemePairs.map((pair, index) => (
            <Reveal key={pair.claim} delay={index * 40}>
              <div
                className={`grid grid-cols-1 md:grid-cols-2 ${
                  index !== schemePairs.length - 1 ? 'border-b border-background-200' : ''
                }`}
              >
                <div className="px-5 md:px-6 py-5 bg-accent-50/60">
                  <span className="md:hidden text-xs font-semibold text-accent-700">话术</span>
                  <p className="mt-1 md:mt-0 text-sm md:text-[15px] font-medium leading-7 text-accent-900">{pair.claim}</p>
                </div>
                <div className="px-5 md:px-6 py-5 bg-secondary-50/60 md:border-l md:border-background-200">
                  <span className="md:hidden text-xs font-semibold text-secondary-800">事实</span>
                  <p className="mt-1 md:mt-0 text-sm leading-7 text-foreground-700">{pair.truth}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}